var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Vue from "vue";
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];
    return arr2;
  }
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function reflectionIsSupported() {
  return typeof Reflect !== "undefined" && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function(key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function(key) {
    forwardMetadata(to, from, key);
  });
}
function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function(metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);
    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}
var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function(target, key, index) {
    var Ctor = typeof target === "function" ? target : target.constructor;
    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }
    if (typeof index !== "number") {
      index = void 0;
    }
    Ctor.__decorators__.push(function(options) {
      return factory(options, key, index);
    });
  };
}
function isPrimitive(value) {
  var type = _typeof(value);
  return value == null || type !== "object" && type !== "function";
}
function collectDataFromConstructor(vm, Component2) {
  var originalInit = Component2.prototype._init;
  Component2.prototype._init = function() {
    var _this = this;
    var keys = Object.getOwnPropertyNames(vm);
    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }
    keys.forEach(function(key2) {
      Object.defineProperty(_this, key2, {
        get: function get() {
          return vm[key2];
        },
        set: function set(value) {
          vm[key2] = value;
        },
        configurable: true
      });
    });
  };
  var data = new Component2();
  Component2.prototype._init = originalInit;
  var plainData = {};
  Object.keys(data).forEach(function(key) {
    if (data[key] !== void 0) {
      plainData[key] = data[key];
    }
  });
  return plainData;
}
var $internalHooks = [
  "data",
  "beforeCreate",
  "created",
  "beforeMount",
  "mounted",
  "beforeDestroy",
  "destroyed",
  "beforeUpdate",
  "updated",
  "activated",
  "deactivated",
  "render",
  "errorCaptured",
  "serverPrefetch"
];
function componentFactory(Component2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  options.name = options.name || Component2._componentTag || Component2.name;
  var proto = Component2.prototype;
  Object.getOwnPropertyNames(proto).forEach(function(key) {
    if (key === "constructor") {
      return;
    }
    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }
    var descriptor = Object.getOwnPropertyDescriptor(proto, key);
    if (descriptor.value !== void 0) {
      if (typeof descriptor.value === "function") {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component2);
    }
  });
  var decorators = Component2.__decorators__;
  if (decorators) {
    decorators.forEach(function(fn) {
      return fn(options);
    });
    delete Component2.__decorators__;
  }
  var superProto = Object.getPrototypeOf(Component2.prototype);
  var Super = superProto instanceof Vue ? superProto.constructor : Vue;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component2, Super);
  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component2);
  }
  return Extended;
}
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
  Object.getOwnPropertyNames(Original).forEach(function(key) {
    if (shouldIgnore[key]) {
      return;
    }
    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }
    var descriptor = Object.getOwnPropertyDescriptor(Original, key);
    if (!hasProto) {
      if (key === "cid") {
        return;
      }
      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    }
    Object.defineProperty(Extended, key, descriptor);
  });
}
function Component(options) {
  if (typeof options === "function") {
    return componentFactory(options);
  }
  return function(Component2) {
    return componentFactory(Component2, options);
  };
}
Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};
globalThis && globalThis.__spreadArrays || function() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
};
var reflectMetadataIsSupported = typeof Reflect !== "undefined" && typeof Reflect.getMetadata !== "undefined";
function applyMetadata(options, target, key) {
  if (reflectMetadataIsSupported) {
    if (!Array.isArray(options) && typeof options !== "function" && !options.hasOwnProperty("type") && typeof options.type === "undefined") {
      var type = Reflect.getMetadata("design:type", target, key);
      if (type !== Object) {
        options.type = type;
      }
    }
  }
}
function Prop(options) {
  if (options === void 0) {
    options = {};
  }
  return function(target, key) {
    applyMetadata(options, target, key);
    createDecorator(function(componentOptions, k) {
      (componentOptions.props || (componentOptions.props = {}))[k] = options;
    })(target, key);
  };
}
function Ref(refKey) {
  return createDecorator(function(options, key) {
    options.computed = options.computed || {};
    options.computed[key] = {
      cache: false,
      get: function() {
        return this.$refs[refKey || key];
      }
    };
  });
}
function Watch(path, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
  return createDecorator(function(componentOptions, handler) {
    if (typeof componentOptions.watch !== "object") {
      componentOptions.watch = /* @__PURE__ */ Object.create(null);
    }
    var watch = componentOptions.watch;
    if (typeof watch[path] === "object" && !Array.isArray(watch[path])) {
      watch[path] = [watch[path]];
    } else if (typeof watch[path] === "undefined") {
      watch[path] = [];
    }
    watch[path].push({ handler, deep, immediate });
  });
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
let NativeEllipsis$1 = class extends Vue {
  constructor() {
    super(...arguments);
    __publicField(this, "text");
    __publicField(this, "visibleLine");
    __publicField(this, "ellipsis");
    __publicField(this, "useInnerHtml");
  }
};
__decorateClass$2([
  Prop({ type: String })
], NativeEllipsis$1.prototype, "text", 2);
__decorateClass$2([
  Prop({ type: Number })
], NativeEllipsis$1.prototype, "visibleLine", 2);
__decorateClass$2([
  Prop({ type: Boolean })
], NativeEllipsis$1.prototype, "ellipsis", 2);
__decorateClass$2([
  Prop({ type: Boolean })
], NativeEllipsis$1.prototype, "useInnerHtml", 2);
NativeEllipsis$1 = __decorateClass$2([
  Component({
    name: "native-ellipsis"
  })
], NativeEllipsis$1);
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: ["vue-ellipsis-native", { ellipsis: _vm.ellipsis }], style: { webkitLineClamp: _vm.visibleLine } }, [_vm.useInnerHtml ? _c("span", { staticClass: "vue-ellipsis-native-html", domProps: { "innerHTML": _vm._s(_vm.text) } }) : _c("span", { staticClass: "vue-ellipsis-native-text" }, [_vm._v(_vm._s(_vm.text))])]);
};
var staticRenderFns$2 = [];
var NativeEllipsis_vue_vue_type_style_index_0_scoped_true_lang = "";
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(NativeEllipsis$1, render$2, staticRenderFns$2, false, __vue2_injectStyles$2, "b754b31e", null, null);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var NativeEllipsis = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
function computeStyle(element, prop) {
  if (!window.getComputedStyle) {
    window.getComputedStyle = function(el) {
      this.getPropertyValue = function(key) {
        const regex = /(-([a-z]){1})/g;
        if (key === "float") {
          key = "styleFloat";
        }
        if (regex.test(key)) {
          key = key.replace(regex, function() {
            return arguments[2].toUpperCase();
          });
        }
        return el.currentStyle && el.currentStyle[key] ? el.currentStyle[key] : null;
      };
      return this;
    };
  }
  return window.getComputedStyle(element, null).getPropertyValue(prop);
}
function getLineHeight(element) {
  const lineHeight = computeStyle(element, "line-height");
  if (lineHeight === "normal") {
    const dom = document.createElement("span");
    dom.style.width = "300px";
    dom.style.position = "absolute";
    dom.style.visibility = "hidden";
    dom.innerText = "ruofee";
    element.appendChild(dom);
    const height = dom.clientHeight;
    element.removeChild(dom);
    return height * 1.1;
  }
  return parseFloat(lineHeight);
}
function registerWordBreak(element) {
  const wordBreak = computeStyle(element, "word-break");
  const overflowWrap = computeStyle(element, "overflow-wrap");
  if (wordBreak !== "word-break" && wordBreak !== "break-all" && overflowWrap !== "break-word") {
    const styleWordBreak = element.style.wordBreak;
    element.style.wordBreak = "break-word";
    return styleWordBreak;
  }
}
function setWordBreak(element, value) {
  element.style.wordBreak = value;
}
function getMiddle(l, r) {
  return Math.floor((l + r) / 2);
}
function binarySearch(l, r, handle, handleResult) {
  while (l < r) {
    const m = getMiddle(l, r);
    if (handleResult(l, r, m)) {
      break;
    }
    if (handle(l, r, m)) {
      r = m;
    } else {
      l = m;
    }
  }
}
function isRegExp(variable) {
  return variable instanceof RegExp;
}
function isString(variable) {
  return typeof variable === "string";
}
function isFunction(variable) {
  return typeof variable === "function";
}
const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
const isSupportNativeEllipsis = isBrowser && typeof document.body.style.webkitLineClamp !== "undefined";
const isSupportResizeObserver = isBrowser && typeof ResizeObserver !== "undefined";
function createSpan(text) {
  const span = document.createElement("span");
  span.className = "vue-ellipsis-js-content-text";
  span.textContent = text;
  return span;
}
function wrapTextChildNodesWithSpan(node) {
  var _a;
  if (!isBrowser) {
    return;
  }
  if (node.nodeType === Node.TEXT_NODE) {
    if (node.textContent) {
      (_a = node.parentNode) == null ? void 0 : _a.replaceChild(createSpan(node.textContent), node);
    }
  } else {
    node.childNodes.forEach((item) => {
      wrapTextChildNodesWithSpan(item);
    });
  }
}
function getElementHeight(element) {
  return element.clientHeight;
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
let JsEllipsis$1 = class extends Vue {
  constructor() {
    super(...arguments);
    __publicField(this, "text");
    __publicField(this, "visibleLine");
    __publicField(this, "visibleHeight");
    __publicField(this, "maxLine");
    __publicField(this, "maxHeight");
    __publicField(this, "ellipsis");
    __publicField(this, "endExcludes");
    __publicField(this, "useInnerHtml");
    __publicField(this, "reflowOnResize");
    __publicField(this, "onReflow");
    __publicField(this, "onEllipsisClick");
    __publicField(this, "ref");
    __publicField(this, "textRef");
    __publicField(this, "ellipsisRef");
    __publicField(this, "truncating");
    __publicField(this, "observer");
  }
  onWatch() {
    this.reflow();
  }
  handleOnReflow(ellipsis, result) {
    if (this.onReflow && isFunction(this.onReflow)) {
      this.onReflow(ellipsis, result);
    }
  }
  handleEllipsisClick() {
    if (this.onEllipsisClick && isFunction(this.onEllipsisClick)) {
      this.onEllipsisClick();
    }
  }
  reflow() {
    if (!this.ref || !this.textRef || !this.ellipsisRef || this.truncating) {
      return;
    }
    this.ellipsisRef.style.display = "none";
    if (this.useInnerHtml) {
      this.textRef.innerHTML = this.text;
    } else {
      this.textRef.innerText = this.text;
    }
    if (!this.ellipsis) {
      return;
    }
    const lineHeight = getLineHeight(this.ref);
    const wordBreak = registerWordBreak(this.textRef);
    const visibleMaxHeight = typeof this.visibleHeight === "undefined" ? lineHeight * this.visibleLine : this.visibleHeight;
    const maxHeight = typeof this.maxHeight === "undefined" ? typeof this.maxLine === "undefined" ? visibleMaxHeight : lineHeight * this.maxLine : this.maxHeight;
    const height = getElementHeight(this.ref);
    if (height <= Math.max(maxHeight, visibleMaxHeight)) {
      this.handleOnReflow(false, this.text);
      if (isString(wordBreak)) {
        setWordBreak(this.textRef, wordBreak);
      }
      return;
    }
    this.truncating = true;
    this.ellipsisRef.style.display = "inline";
    if (this.useInnerHtml) {
      wrapTextChildNodesWithSpan(this.textRef);
      this.truncateHTML(this.ref, this.textRef, visibleMaxHeight);
    } else {
      this.truncateText(this.ref, this.textRef, visibleMaxHeight);
    }
    if (isString(wordBreak)) {
      setWordBreak(this.textRef, wordBreak);
    }
    this.truncating = false;
  }
  truncateText(container, textContainer, max) {
    const text = textContainer.textContent || "";
    let currentText = "";
    binarySearch(0, text.length, (l, r, m) => {
      const temp = text.slice(l, m);
      textContainer.innerText = currentText + temp;
      const height = getElementHeight(container);
      const isExceededMaximun = height > max;
      if (!isExceededMaximun) {
        currentText += temp;
      }
      return isExceededMaximun;
    }, (l, r, m) => l === m);
    currentText = this.handleEndExcludes(currentText);
    textContainer.innerText = currentText;
    this.handleOnReflow(true, currentText);
  }
  truncateHTML(container, textContainer, max) {
    const children = textContainer.childNodes;
    if (children.length === 1) {
      const node = children[0];
      if (node.nodeType === Node.TEXT_NODE) {
        this.truncateText(container, textContainer, max);
      } else {
        const html = node.innerHTML;
        node.innerHTML = "";
        const height = getElementHeight(container);
        if (height > max) {
          textContainer.removeChild(node);
          this.handleOnReflow(true, textContainer.innerHTML);
          return;
        }
        node.innerHTML = html;
        this.truncateHTML(container, node, max);
      }
    } else {
      const nodes = [].slice.call(children);
      const _nodes = [];
      let i = 0;
      binarySearch(0, nodes.length, (l, r, m) => {
        textContainer.innerHTML = "";
        const currentNodes = nodes.slice(l, m);
        _nodes.forEach((node) => {
          textContainer.appendChild(node);
        });
        currentNodes.forEach((node) => {
          textContainer.appendChild(node);
        });
        const height = getElementHeight(container);
        const isExceededMaximun = height > max;
        if (!isExceededMaximun) {
          currentNodes.forEach((node) => {
            _nodes.push(node);
          });
        }
        return isExceededMaximun;
      }, (l, r, m) => {
        if (l === m) {
          const height = getElementHeight(container);
          const isExceededMaximun = height > max;
          i = m;
          if (!isExceededMaximun) {
            textContainer.appendChild(nodes[i]);
          }
          return true;
        }
        return false;
      });
      if (textContainer.childNodes[i]) {
        this.truncateHTML(container, textContainer.childNodes[i], max);
      }
    }
  }
  isTextInEndExcludes(text) {
    for (const item of this.endExcludes) {
      if (isRegExp(item)) {
        if (item.test(text)) {
          return true;
        }
      } else if (item === text) {
        return true;
      }
    }
    return false;
  }
  handleEndExcludes(text) {
    while (!!text.length && this.isTextInEndExcludes(text[text.length - 1])) {
      text = text.slice(0, -1);
    }
    return text;
  }
  mounted() {
    this.reflow();
    if (this.ref && this.reflowOnResize) {
      if (isSupportResizeObserver) {
        this.observer = new ResizeObserver(this.reflow);
        this.observer.observe(this.ref);
      } else {
        window.addEventListener("resize", this.reflow);
      }
    }
  }
  beforeDestroy() {
    if (isSupportResizeObserver && this.observer) {
      this.observer.disconnect && this.observer.disconnect();
    } else {
      window.removeEventListener("resize", this.reflow);
    }
  }
};
__decorateClass$1([
  Prop({ type: String, required: true })
], JsEllipsis$1.prototype, "text", 2);
__decorateClass$1([
  Prop({ type: Number })
], JsEllipsis$1.prototype, "visibleLine", 2);
__decorateClass$1([
  Prop({ type: Number })
], JsEllipsis$1.prototype, "visibleHeight", 2);
__decorateClass$1([
  Prop({ type: Number })
], JsEllipsis$1.prototype, "maxLine", 2);
__decorateClass$1([
  Prop({ type: Number })
], JsEllipsis$1.prototype, "maxHeight", 2);
__decorateClass$1([
  Prop({ type: Boolean })
], JsEllipsis$1.prototype, "ellipsis", 2);
__decorateClass$1([
  Prop({ type: Array })
], JsEllipsis$1.prototype, "endExcludes", 2);
__decorateClass$1([
  Prop({ type: Boolean })
], JsEllipsis$1.prototype, "useInnerHtml", 2);
__decorateClass$1([
  Prop({ type: Boolean })
], JsEllipsis$1.prototype, "reflowOnResize", 2);
__decorateClass$1([
  Prop({ type: Function })
], JsEllipsis$1.prototype, "onReflow", 2);
__decorateClass$1([
  Prop({ type: Function })
], JsEllipsis$1.prototype, "onEllipsisClick", 2);
__decorateClass$1([
  Ref("ref")
], JsEllipsis$1.prototype, "ref", 2);
__decorateClass$1([
  Ref("textRef")
], JsEllipsis$1.prototype, "textRef", 2);
__decorateClass$1([
  Ref("ellipsisRef")
], JsEllipsis$1.prototype, "ellipsisRef", 2);
__decorateClass$1([
  Watch("text"),
  Watch("ellipsis"),
  Watch("useInnerHtml"),
  Watch("maxLine"),
  Watch("visibleLine"),
  Watch("maxHeight"),
  Watch("visibleHeight"),
  Watch("ellipsisNode"),
  Watch("endExcludes")
], JsEllipsis$1.prototype, "onWatch", 1);
JsEllipsis$1 = __decorateClass$1([
  Component({
    name: "js-ellipsis"
  })
], JsEllipsis$1);
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "ref", staticClass: "vue-ellipsis-js" }, [_c("span", { ref: "textRef", staticClass: "vue-ellipsis-js-content" }), _c("span", { ref: "ellipsisRef", staticClass: "vue-ellipsis-js-ellipsis", on: { "click": _vm.handleEllipsisClick } }, [_vm._t("ellipsisNode")], 2)]);
};
var staticRenderFns$1 = [];
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(JsEllipsis$1, render$1, staticRenderFns$1, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var JsEllipsis = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
const ELLIPSIS_NODE = "...";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
function getDefaultEndExcludes() {
  return [];
}
let VueEllipsisComponent = class extends Vue {
  constructor() {
    super(...arguments);
    __publicField(this, "text");
    __publicField(this, "visibleLine");
    __publicField(this, "visibleHeight");
    __publicField(this, "maxLine");
    __publicField(this, "maxHeight");
    __publicField(this, "ellipsis");
    __publicField(this, "ellipsisNode");
    __publicField(this, "endExcludes");
    __publicField(this, "useInnerHtml");
    __publicField(this, "reflowOnResize");
    __publicField(this, "onReflow");
    __publicField(this, "onEllipsisClick");
  }
  get useNativeEllipsis() {
    const useNativeEllipsis = isSupportNativeEllipsis && (typeof this.maxLine === "undefined" || this.maxLine === this.visibleLine) && this.endExcludes.length === 0 && this.ellipsisNode === ELLIPSIS_NODE && typeof this.$slots.ellipsisNode === "undefined" && typeof this.maxHeight === "undefined" && typeof this.visibleHeight === "undefined" && typeof this.onReflow === "undefined" && typeof this.onEllipsisClick === "undefined";
    return useNativeEllipsis;
  }
};
__decorateClass([
  Prop({ type: String, required: true })
], VueEllipsisComponent.prototype, "text", 2);
__decorateClass([
  Prop({ type: Number, default: 1 })
], VueEllipsisComponent.prototype, "visibleLine", 2);
__decorateClass([
  Prop({ type: Number })
], VueEllipsisComponent.prototype, "visibleHeight", 2);
__decorateClass([
  Prop({ type: Number })
], VueEllipsisComponent.prototype, "maxLine", 2);
__decorateClass([
  Prop({ type: Number })
], VueEllipsisComponent.prototype, "maxHeight", 2);
__decorateClass([
  Prop({ type: Boolean, default: true })
], VueEllipsisComponent.prototype, "ellipsis", 2);
__decorateClass([
  Prop({ type: String, default: ELLIPSIS_NODE })
], VueEllipsisComponent.prototype, "ellipsisNode", 2);
__decorateClass([
  Prop({ type: Array, default: getDefaultEndExcludes })
], VueEllipsisComponent.prototype, "endExcludes", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], VueEllipsisComponent.prototype, "useInnerHtml", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], VueEllipsisComponent.prototype, "reflowOnResize", 2);
__decorateClass([
  Prop({ type: Function })
], VueEllipsisComponent.prototype, "onReflow", 2);
__decorateClass([
  Prop({ type: Function })
], VueEllipsisComponent.prototype, "onEllipsisClick", 2);
VueEllipsisComponent = __decorateClass([
  Component({
    name: "vue-ellipsis",
    components: {
      NativeEllipsis,
      JsEllipsis
    }
  })
], VueEllipsisComponent);
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "vue-ellipsis" }, [_vm.useNativeEllipsis ? _c("native-ellipsis", { attrs: { "text": _vm.text, "visible-line": _vm.visibleLine, "ellipsis": _vm.ellipsis, "use-inner-html": _vm.useInnerHtml } }) : _c("js-ellipsis", { attrs: { "text": _vm.text, "use-inner-html": _vm.useInnerHtml, "visible-line": _vm.visibleLine, "visible-height": _vm.visibleHeight, "max-line": _vm.maxLine, "max-height": _vm.maxHeight, "ellipsis": _vm.ellipsis, "end-excludes": _vm.endExcludes, "reflow-on-resize": _vm.reflowOnResize, "on-reflow": _vm.onReflow, "on-ellipsis-click": _vm.onEllipsisClick }, scopedSlots: _vm._u([{ key: "ellipsisNode", fn: function() {
    return [!_vm.$slots.ellipsisNode ? [_vm._v(_vm._s(_vm.ellipsisNode))] : _vm._e(), _vm._t("ellipsisNode")];
  }, proxy: true }], null, true) })], 1);
};
var staticRenderFns = [];
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(VueEllipsisComponent, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var VueEllipsis = /* @__PURE__ */ function() {
  return __component__.exports;
}();
var main = {
  install(Vue2) {
    Vue2.component("vue-ellipsis", VueEllipsis);
  }
};
export { VueEllipsis, main as default };
(function() {try {var elementStyle = document.createElement('style');elementStyle.innerText = ".vue-ellipsis-native.ellipsis[data-v-b754b31e]{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;word-break:break-word;-webkit-box-orient:vertical}\n";document.head.appendChild(elementStyle);} catch(error) {console.error(error, 'unable to concat style inside the bundled file')}})()


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-ellipsis-component/lib/vue-ellipsis-component.es.js
// module id = bUZs
// module chunks = 113